import React, { Component } from "react";
import { Navigate } from "react-router-dom";
import "./contactUs.css";
import Footer from "../../components/Footer/Footer";

export default class ContactUs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fullName: "",
      email: "",
      contactNumber: "",
      projectType: "",
      projectDescription: "",
      consentGiven: false,
      errorMessage: "",
      redirect: false,
      isSubmitting: false,
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleCheckboxChange = (e) => {
    this.setState({ consentGiven: e.target.checked });
  };

  handleSubmit = (e) => {
    e.preventDefault();

    const {
      fullName,
      email,
      contactNumber,
      projectType,
      projectDescription,
      consentGiven,
    } = this.state;

    // Validate required fields
    if (!consentGiven) {
      this.setState({ errorMessage: "Please accept the privacy agreement." });
      return;
    }

    if (!fullName || !email || !contactNumber || !projectType || !projectDescription) {
      this.setState({ errorMessage: "Please fill in all required fields." });
      return;
    }

    this.setState({ isSubmitting: true, errorMessage: "" });

    // Prepare data
    const payload = {
      full_name: fullName,
      email_address: email,
      contact_number: contactNumber,
      project_type: projectType,
      project_description: projectDescription,
    };

    // Submit API
    fetch("https://ambrumsolutions.com/api/ambrum-website/talk-with-ambrum", {
      method: "POST",
      headers: { "Content-Type": "application/json", accept: "application/json" },
      body: JSON.stringify(payload),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status && data.code === 200) {
          this.setState({ redirect: true });
        } else {
          this.setState({
            errorMessage: data.message || "Submission failed. Please try again.",
            isSubmitting: false,
          });
        }
      })
      .catch(() => {
        this.setState({
          errorMessage: "Something went wrong. Please try again later.",
          isSubmitting: false,
        });
      });
  };

  render() {
    if (this.state.redirect) {
      return <Navigate to="/thankyou" />;
    }

    return (
      <div>
        <div className="contatct-home">
          <section className="contatct-hero">
            <h1 className="contatct-hero-text">
              Got an Idea? <br />
              We’ll <span className="highlight">Make It Real. </span>
            </h1>
            <p className="contatct-subtext">
              Whether you’re looking to build a cutting-edge app, supercharge your brand, or explore digital <br />
              transformation, our team is ready to collaborate. Fill out the form and we’ll get back to you within 24 hours.
            </p>
          </section>

          <form className="contact-form" onSubmit={this.handleSubmit}>
            {this.state.errorMessage && (
              <div className="form-error mb-3">{this.state.errorMessage}</div>
            )}

            <div className="form-group">
              <label>Full Name</label>
              <input
                type="text"
                name="fullName"
                placeholder="Enter your full name"
                value={this.state.fullName}
                onChange={this.handleChange}
              />
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Email Address</label>
                <input
                  type="email"
                  name="email"
                  placeholder="Enter your email address"
                  value={this.state.email}
                  onChange={this.handleChange}
                />
              </div>
              <div className="form-group">
                <label>Contact Number</label>
                <input
                  type="text"
                  name="contactNumber"
                  placeholder="Enter your contact number"
                  value={this.state.contactNumber}
                  onChange={this.handleChange}
                />
              </div>
            </div>

            <div className="form-group">
              <label>Project Type</label>
              <select
                name="projectType"
                value={this.state.projectType}
                onChange={this.handleChange}
              >
                <option value="">Select Project Type</option>
                <option>Web Development</option>
                <option>Mobile App</option>
                <option>Digital Marketing</option>
                <option>Other</option>
              </select>
            </div>

            <div className="form-group">
              <label>Tell Us About Your Project</label>
              <textarea
                rows="4"
                name="projectDescription"
                placeholder="Describe your project..."
                value={this.state.projectDescription}
                onChange={this.handleChange}
              ></textarea>
            </div>

            <div className="form-group checkbox-group">
              <label className="checkbox-wrapper">
                <input
                  type="checkbox"
                  id="consent"
                  onChange={this.handleCheckboxChange}
                  checked={this.state.consentGiven}
                />
                I agree to give the above personal data to Ambrum. Ambrum may use the data to evaluate,
                store for further processing and use anonymised data to train our models <br /> to improve our
                recruitment process.
              </label>
            </div>

            <button
              type="submit"
              className="submit-button"
              disabled={this.state.isSubmitting}
            >
              {this.state.isSubmitting ? "Submitting..." : "Submit"}
            </button>
          </form>
        </div>

        <Footer />
      </div>
    );
  }
}
